<div style="vertical-align: top; margin: 20px; width: 500px;" valign="top">
  <h2>Anulowanie rezerwacji miejsca parkingowego</h2>
  <div class="ui-g ui-fluid">
    <div *ngIf="!externalQrCode" class="ui-g-6">
      <label class="label">Kod:</label>
      <input type="text" pInputText [(ngModel)]="qrCode" />
    </div>
    <div *ngIf="externalQrCode" class="ui-g-12">
      <p>Aby anulować rezerwację należy wcisnąć przycisk "Anulowanie rezerwacji"</p>
    </div>
    <div class="ui-g-12">
      <span style="float: right;">
        <button pButton type="button" (click)="cancelReservation()" label="Anuluj rezerwację"></button>
      </span>
    </div>
  </div>
</div>
